module.exports = function additiveSymmetric(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += ((a[i] - b[i]) * (a[i] - b[i]) * (a[i] + b[i])) / (a[i] * b[i]);
    }
    return 2 * d;
};



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/distances/additiveSymmetric.js
// module id = 147
// module chunks = 0